/* eslint-disable no-unused-vars */
import React, { useCallback, useState } from "react";
// import { useNavigate } from "react-router-dom";
import Style from "../../assets/css/main.module.css";
import caretDownIcon from "../../assets/icons/caret-down.svg";
import caretUpIcon from "../../assets/icons/caret-up.svg";
import downloadIcon from "../../assets/icons/download.svg";
// import printIcon from "../../assets/icons/print.svg";
import { currencyFormat } from "../../library/currency";
import api from "../../api/api";
import uuidv4 from "../../utils/uuid";

export default function Ticket({ item, type }) {
  // const navigate = useNavigate();

  // console.log(item.details.booking_id);

  // const handlerPrint = () => {
  //       navigate("/print", {
  //             state: {
  //                   action: "print",
  //                   data: item,
  //                   type: "general",
  //             },
  //       });
  // };

  // const downloadImage = () => {
  //       navigate("/print", {
  //             state: {
  //                   action: "download",
  //                   data: item,
  //                   type: "general",
  //             },
  //       });
  // };

  const fetchDownloadTicket = useCallback(async () => {
    const res = await api.downloadTicket(item.details.booking_id);
    if (res?.status === 200) {
      const url = window.URL.createObjectURL(res.data);
      const link = document.createElement("a");
      link.href = url;
      link.download = `SHOHOZ.COM_TICKET${uuidv4()}.pdf`;
      link.dispatchEvent(new MouseEvent("click"));
    }
  }, [item.details.booking_id]);

  const [more, setMore] = useState(false);
  const moreHandler = () => setMore(!more);
  return (
    <div className="d-flex flex-column mb-2">
      <div
        className={`${Style.bg_primary_200} ${Style.border_primary} d-flex flex-column flex-md-row justify-content-between align-items-center gap-2 px-3`}
        style={{ borderLeft: "5px solid" }}
      >
        <div className="w-md-50 w-100  d-flex flex-column">
          <div
            className={`${Style.text_primary} ${Style.fs_18} ${Style.fw_600}`}
          >
            {item.details.park.name}
          </div>
          <div className={`${Style.fs_14} ${Style.fw_350}`}>
            Purchase ID: {item.details.pnr}
          </div>
          <div className={`${Style.fs_14} ${Style.fw_350}`}>
            Booked on: {item.details.booking_on}
          </div>
        </div>
        <div className="w-md-50 w-100 d-flex flex-md-column flex-row justify-content-between align-items-end">
          {type === "active" && <div>
            <button
              type="button"
              onClick={fetchDownloadTicket}
              className={`${Style.bg_none} ${Style.fs_16} ${Style.fw_350} ${Style.text_primary} border-0 d-flex flex-md-row flex-column-reverse align-items-center gap-2`}
            >
              <div>Download</div>
              <div>
                <img src={downloadIcon} alt="download" />
              </div>
            </button>
          </div>}
          {/* <div>
                                    <button
                                          type="button"
                                          onClick={handlerPrint}
                                          className={`${Style.bg_none} ${Style.fs_16} ${Style.fw_350} ${Style.text_primary} border-0 flex-md-row flex-column-reverse d-flex align-items-center gap-2`}
                                    >
                                          <div>Print</div>
                                          <div>
                                                <img src={printIcon} alt="download" />
                                          </div>
                                    </button>
                              </div> */}
          <div>
            <button
              type="button"
              onClick={moreHandler}
              className={`${Style.bg_none} ${Style.fs_16} ${Style.fw_350} ${Style.text_primary} border-0 d-flex flex-md-row flex-column-reverse align-items-center gap-2`}
            >
              <div className="d-none d-md-block">See Receipt</div>
              <div className="d-bolck d-md-none">Receipt</div>
              <div>
                <img src={more ? caretUpIcon : caretDownIcon} alt="download" />
              </div>
            </button>
          </div>
        </div>
      </div>
      {more && (
        <div className={`${Style.bg_gray_200} d-flex flex-column gap-2 px-2`}>
          <div className="d-flex align-items-center">
            <div
              className={`${Style.text_primary} ${Style.fs_16} ${Style.fw_600} w-75`}
            >
              Tickets
            </div>
            <div
              className={`${Style.text_primary} ${Style.fs_16} ${Style.fw_600} w-25 text-end`}
            >
              Price
            </div>
          </div>
          {item.tickets.map((ticket) => (
            <div
              key={Math.random()}
              className={`${Style.fs_16} ${Style.fw_350} d-flex align-items-center`}
            >
              <div className="w-75 d-flex flex-column">
                <div>{`${ticket.name} (${currencyFormat(ticket.price)}x${ticket.count})`}</div>
                {ticket.babulandOrderId && (
                  <div className={`${Style.fs_12} fw-bold`}>
                    <span>Babuland Order Id: </span>
                    <span>{ticket.babulandOrderId.join(", ")}</span>
                  </div>
                )}
                <div className={`${Style.fs_12} fw-bold`}>
                  <span>Branch: </span>
                  <span>{ticket.branch}</span>
                </div>
                <div className={`${Style.fs_12} fw-bold`}>
                  <span>
                    {type === "active" ? "Valid till" : "Expired on"}:{" "}
                  </span>
                  <span>{ticket.expiry || "Unlimited"}</span>
                </div>
              </div>
              <div className="w-25 text-end">
                {currencyFormat(ticket.price * ticket.count)}
              </div>
            </div>
          ))}
          <div
            className={`${Style.fs_16} ${Style.fw_350} d-flex align-items-center border-top border-1 border-black`}
          >
            <div className="w-75">Total</div>
            <div className="w-25 text-end">
              {currencyFormat(
                item.tickets.reduce(
                  (accumulator, currentItem) =>
                    accumulator + currentItem.price * currentItem.count,
                  0
                )
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
